import map from 'lodash/map'
import { UNLOCKED } from '@/constants/lock-status.js'

export default {
  frequentContacts: state => state.users.slice(0, 20)
    .filter(user => user.uid !== state.user.uid)
    .slice(0, 10),
  followingUserIds: state => state.user
    ? map(state.user.followedUserIds, 'id')
    : [],
  lockStatus: state => {
    if (state.user.jobNumber === '10001') {
      return UNLOCKED
    } else {
      return (((state.selectedCycleId
        ? state.yearCycles[state.activeYearIndex]
        : [])[0]?.lockStatus))
    }
  },
  lang: state => state.app.lang
}
